import { isDarkColor } from "common/utilities/colors/colors";
import type { SequenceFeature } from "sequenceAnalyser/api/sequenceAnalyserApiClient";
import type { ColumnsLetterOccurrences } from "sequenceAnalyser/utilities/colorCalculations/colorCalculations";
import { residueColor } from "sequenceAnalyser/utilities/colorCalculations/colorCalculations";
import type { SelectedColorScheme } from "sequenceAnalyser/utilities/colors";
import { featureDefinitionsForRegion } from "sequenceAnalyser/utilities/features/features";
import type { FeatureDefinitions, SequenceAnalyserTableView } from "sequenceAnalyser/utilities/sequenceAnalyser.types";
import { formatResidueForView } from "sequenceAnalyser/utilities/sequenceAnalyser/sequenceAnalyser";

interface Params {
  sequenceId: number;
  position: number;
  hasFeatures: boolean;
  features: SequenceFeature[];
  noFeaturesColors: boolean;
  featureDefinitions: FeatureDefinitions;
  residue: string;
  view: SequenceAnalyserTableView;
  rowId: number;
  columnsLetterOccurrences: ColumnsLetterOccurrences;
  colors?: SelectedColorScheme;
  maskingResidue: string;
}

/**
 * Based on current settings, calculate colors, feature definitions etc. to show
 */
function residueProcessor(params: Params) {
  const {
    sequenceId,
    position,
    hasFeatures,
    features,
    noFeaturesColors,
    featureDefinitions,
    residue,
    view,
    rowId,
    columnsLetterOccurrences,
    colors,
    maskingResidue,
  } = params;

  const residueId = `seq-${sequenceId}-${position}`;
  const defs = hasFeatures ? featureDefinitionsForRegion(features, featureDefinitions, position) : [];
  const visibleDefs = defs.filter((feature) => feature.visible);
  const isFeatureColorDark =
    visibleDefs.length > 0 && visibleDefs[0].color ? isDarkColor(visibleDefs[0].color) : undefined;
  const residueForView = formatResidueForView(
    residue,
    view,
    rowId === 0,
    columnsLetterOccurrences[position][residue],
    maskingResidue,
  );
  const { color, colorOpacity } = residueColor(
    residue,
    residueForView,
    position,
    view,
    colors,
    noFeaturesColors ? [] : defs,
    columnsLetterOccurrences,
  );

  return {
    residueId,
    residueForView,
    position,
    visibleDefs,
    isFeatureColorDark,
    color,
    defs,
    colorOpacity,
  };
}

export default residueProcessor;
